import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from "react-toastify";
import { getStudentListByRouteStopSvc, saveStopStudentSvc } from './routeSvc'

const StudentStopAllocationSlider = (props) => {
    const [loader, setLoader] = useState("none");
    const [lstStudent, setLstStudent] = useState([])
    const [lstSelStopStudent, setLstSelStopStudent] = useState([])
    const [studentId, setStudentId] = useState(0)
    const [foundLst, setFoundLst] = useState([]);
    const [keyObj, setKeyObj] = useState({})
    const [monthInt, setMonthInt] = useState()
    const [month, setMonth] = useState()
    const [dt, setDt] = useState()
    const [year, setYear] = useState()
    const lstMonth = ['Month', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
    const lstYear = [2022, 2023, 2024, 2025, 2026, 2027, 2028,
        2029, 2030, 2031, 2032, 2033, 2034, 2035, 2036,
        2037, 2038, 2039, 2040, 2041, 2042, 2043, 2044,
        2045, 2046, 2047, 2048, 2049, 2050];
    const [tptStartFeeYyyyMm, setTptStartFeeYyyyMm] = useState('')
    console.log(props)

    useEffect(() => {
        getStudentListByRouteStop(props.routeId, props.stopId);
    }, [props.routeId, props.stopId]);

    function getStudentListByRouteStop(pRouteId, pStopId) {
        getStudentListByRouteStopSvc(pRouteId, pStopId, cbStudentList);
    }

    function cbStudentList(data) {
        if (data.SvcStatus === "Success") {
            setLstStudent(data.lstStudent);
            setFoundLst(data.lstStudent);
            setStateSelectedStopStudent(data.lstStudent)
        } else {
            toast.error(data.SvcMsg);
        }
        setLoader("none");
    }

    const colgrp = (
        <colgroup>
            <col width="5%"></col>
            <col width="6%"></col>
            <col width="12%"></col>
            <col width="9%"></col>
            <col width="6%"></col>
            <col width="15%"></col>
            <col width="6%"></col>
        </colgroup>
    );

    function setStateSelectedStopStudent(pLstSelStopStudent) {
        var tmpArr = [];
        for (var i = 0; i < pLstSelStopStudent.length; i++) {
            var obj = pLstSelStopStudent[i];
            if (obj.selected) {
                tmpArr.push(obj.studentId);
            }
        }
        setLstSelStopStudent(tmpArr);
    }
    function handleCBoxChange(pStudentId, status) {
        console.log("handleCBoxChange triggered");
        let objAllocateRoute = {
            routeId: props.routeId,
            stopId: props.stopObj.stopId,
            tptStartFeeYyyyMm: dt,
            studentId: pStudentId,
            flgAllocate: status
        }
        saveStopStudentSvc(objAllocateRoute, cbSaveStopStudent)

    }
    function cbSaveStopStudent(data) {
        setLoader("none");
        if (data.SvcStatus === "Success") {
            toast.success(data.SvcMsg);
            // props.closeSlider();
        } else {
            toast.error(data.SvcMsg);
        }
    }

    const filterKey = (e, key) => {
        let keyword = e.target.value;

        console.log('key = ', key, 'keyword = ', keyword)
        if (keyword !== '') {
            const results = foundLst.filter((obj) => {
                console.log('rslt = ', obj[key], (obj.key !== '' && (obj[key] + '').includes(keyword)), obj.student, keyword)
                return (obj[key] + '').includes(keyword);
            });
            setFoundLst(results);
        } else {
            console.log('keyword is empty or chk is false')
            setFoundLst(lstStudent);
        }

        setKeyObj({ ...keyObj, key: keyword });
    }

    function handleMonthChange(param) {
        var m = lstMonth.indexOf(param)
        // console.log(m)
        setMonth(param)
        var dt = year * 100 + m
        // console.log(dt)
        setDt(dt)
        setMonthInt(m)
    }

    function handleYearChange(param) {
        var dt = param * 100 + monthInt
        // console.log(dt)
        setDt(dt)
        setYear(param)
    }

    return (

        <div
            className="col-sm-11 col-centered padding-remove"
            style={{
                pointerEvents: loader === "none" ? "auto" : "none",
                height: "100%",
                width: "100%",
                background: "#fff",
                border: "1px solid #ccc",
                borderRadius: 10,
            }}
        >
            <div
                className="EnquiryHead col-sm-12 col-centered"
                style={{
                    border: "1px solid #aaa",
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,
                    borderBottomLeftRadius: 5,
                    borderBottomRightRadius: 5,
                    fontWeight: "bold",
                }}
            >
                <h4>Student Stop Allocation</h4>
            </div>

            <form className="form form-horizontal">
                <button
                    type="button"
                    className="btn btn-info text-center btnCloseDiv"
                    onClick={props.closeSlider}
                    style={{ right: "90%" }}
                >
                    <span
                        id="close"
                        title="Close Slider"
                        className="glyphicon glyphicon-remove"
                    ></span>
                </button>

                <div
                    className="tab-pane fade active in"
                    id="morning"
                    style={{ padding: 10, fontWeight: "normal" }}
                >

                    <div className="col-sm-12 form-group">
                        <div
                            className="pull-left padding-remove col-sm-2"
                            style={{ width: '15%', border: "1px solid #b4b4b4", marginRight: '1%' }}
                        >
                            <label
                                className="col-sm-7 control-label padding-remove"
                                style={{
                                    color: "#fff",
                                    background: "#ccc",
                                    textAlign: 'center'
                                }}
                            >
                                Route No.:
                            </label>
                            <label className="col-sm-5 control-label padding-remove pull-right">
                                {props.routeNo}
                            </label>
                        </div>
                        <div
                            className="pull-left padding-remove col-sm-2"
                            style={{ width: '15%', border: "1px solid #b4b4b4", marginRight: '1%' }}
                        >
                            <label
                                className="col-sm-7 control-label padding-remove"
                                style={{
                                    color: "#fff",
                                    background: "#ccc",
                                    textAlign: 'center'
                                }}
                            >
                                Stop No.:
                            </label>
                            <label className="col-sm-5 control-label padding-remove pull-right">
                                {props.stopObj.stopNo}
                            </label>
                        </div>
                        <div
                            className="pull-left padding-remove col-sm-8"
                            style={{ border: "1px solid #b4b4b4", marginRight: '1%', width: '35%' }}
                        >
                            <label
                                className="col-sm-2 control-label padding-remove"
                                style={{
                                    color: "#fff",
                                    background: "#ccc",
                                    width: "28%",
                                    textAlign: 'center'
                                }}
                            >
                                Stop Desc:
                            </label>
                            <label className="control-label padding-remove pull-left" style={{ width: 'auto', left: '28%', position: 'absolute' }}>
                                {props.stopObj.stopDesc}
                            </label>
                        </div>
                        <div
                            className="pull-left padding-remove col-sm-8"
                            style={{ border: "1px solid #b4b4b4", marginRight: '1%', width: '25%' }}
                        >
                            <label
                                className="col-sm-6 control-label padding-remove"
                                style={{
                                    color: "#fff",
                                    background: "#ccc",
                                    textAlign: 'center'
                                }}
                            >
                                Fee Start Month:
                            </label>

                            <label className="control-label padding-remove pull-left">
                                <select
                                    className="form-control "
                                    style={{ height: 20, fontSize: 11 }}
                                    onChange={(e) => handleYearChange(e.target.value)}
                                    value={year}
                                >
                                    <option value={""}>Year</option>

                                    {lstYear.map((year, idx) => {
                                        return (
                                            <option key={idx} value={year}>{year}</option>
                                        );
                                    })}
                                </select>
                            </label>
                            <label className="control-label padding-remove pull-left">
                                <select
                                    className="form-control"
                                    style={{ height: 20, fontSize: 11 }}
                                    onChange={(e) => handleMonthChange(e.target.value)}
                                    value={month}
                                >
                                    {lstMonth.map((month, idx) => {
                                        return (
                                            <option key={idx} value={month}>{month}</option>
                                        );
                                    })}
                                </select>
                            </label>
                        </div>
                        {/* <div
                                className="pull-left padding-remove col-sm-2"
                                style={{ width: '9%' }}
                            >
                                <label className="col-sm-1 control-label padding-remove">Selected:</label>
                                <label className="control-label padding-remove pull-right" style={{ marginTop: '-5' }}>
                                    <input
                                        type="checkbox"
                                        defaultChecked={false}
                                        onClick={(e) =>
                                            filterKey(e, 'stopNo')
                                        }
                                    />
                                </label>
                            </div> */}
                    </div>
                    {/* </div> */}
                    <div className="row">
                        <div className="col-sm-11" style={{ width: "95%" }}>
                            <table className="tableLayout1">
                                {colgrp}
                                <thead>
                                    <tr>
                                        <th><input onChange={(e) => filterKey(e, 'studentId')} type="text" value={keyObj.studentId} className="form-control inp-search" placeholder="Student Id" /></th>
                                        <th><input onChange={(e) => filterKey(e, 'enrollmentNo')} type="text" value={keyObj.enrollmentNo} className="form-control inp-search" placeholder="Enrolment No." /></th>
                                        <th><input onChange={(e) => filterKey(e, 'student')} type="text" value={keyObj.student} className="form-control inp-search" placeholder="Student" /></th>
                                        <th><input onChange={(e) => filterKey(e, 'phoneNo')} type="text" value={keyObj.phoneNo} className="form-control inp-search" placeholder="Phone No." /></th>
                                        <th><input onChange={(e) => filterKey(e, 'clsSec')} type="text" value={keyObj.clsSec} className="form-control inp-search" placeholder="Class" /></th>
                                        <th><input onChange={(e) => filterKey(e, 'address')} type="text" value={keyObj.address} className="form-control inp-search" placeholder="Address" /></th>
                                        <th>Select</th>
                                    </tr>
                                </thead>
                            </table>
                            <div className="tablebodyWrapper5" >
                                <table className="tableLayout">
                                    {colgrp}
                                    <tbody>
                                        {foundLst.map((obj, idx) => {
                                            return (
                                                <tr
                                                    obj={JSON.stringify(obj)}
                                                    stop-obj={JSON.stringify(props.stopObj)}
                                                    key={idx}
                                                    route-id={props.routeId}
                                                    stop-id={props.stopObj.stopId}
                                                    id={obj.studentId}
                                                    onClick={(e) => setStudentId(obj.studentId)}
                                                    className={
                                                        obj.studentId === studentId ? "selected" : (props.routeId == obj.routeId && props.stopObj.stopNo == obj.stopNo ? "selected-cell" : "")
                                                    }
                                                >
                                                    <td>{obj.studentId}</td>
                                                    <td>{obj.enrollmentNo}</td>
                                                    <td className="text-left">{obj.student}</td>
                                                    <td className="text-left">{obj.phoneNo}</td>
                                                    <td className="text-left">{obj.clsSec}</td>
                                                    <td className="text-left">{obj.address}</td>

                                                    <td className="text-center">
                                                        <input
                                                            type="checkbox"
                                                            defaultChecked={props.routeId == obj.routeId && props.stopObj.stopNo == obj.stopNo}
                                                            onClick={(e) =>
                                                                handleCBoxChange(obj.studentId, e.target.checked)
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </form >
        </div >

    )
}

export default StudentStopAllocationSlider